export default __webpack_public_path__ + "static/media/Tabl_13.44776252.svg";